import { useCallback, useState, useEffect } from "react";

import Router from "../Router/index";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import FeatureTooltip from "../Components/FeatureTooltip/FeatureTooltip";
import NotificationsPermission from "../Components/NotificationsPermission";
import SetupUserPopup from "../Components/SetupUserPopup";
import AddToHome from "../Components/AddToHome/AddToHome";

import { isMobile } from "../utils/helpers";

import "./style.css";

const Layout = () => {
  const [active, setActive] = useState("passive");

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes("android")) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=life.skedy.app";
    } else if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
      window.location.href = "https://apps.apple.com/app/id6748560096";
    }
  }, []);

  const sandwichToggle = useCallback(() => {
    return setActive((postState) =>
      postState === "active" ? "passive" : "active",
    );
  }, []);

  return (
    <div className={`layout`}>
      <div className={`left ${active}`}></div>
      <div className={`right ${active}`} onClick={sandwichToggle}></div>
      <AddToHome />
      <FeatureTooltip menuState={active} togleMenu={sandwichToggle} />
      <NotificationsPermission />
      <SetupUserPopup />
      <Header active={active} sandwichToggle={sandwichToggle} />
      <main>
        <Router />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
